'use client';

import { queryOptions } from '@tanstack/react-query';

import { browserApiRequest } from '@/shared/api';

import {
  CityListSchema,
  deliveryKeys,
  DeliveryOptionListSchema,
  PickupPointListSchema,
} from '../model/delivery';

const encode = (value: string) => encodeURIComponent(value.trim());

export function citiesQueryOptions(query: string) {
  return queryOptions({
    queryKey: deliveryKeys.cities(query.trim().toLowerCase()),
    queryFn: ({ signal }) =>
      browserApiRequest(`/api/delivery/cities?q=${encode(query)}`, CityListSchema, { signal }),
    staleTime: 5 * 60_000,
  });
}

export function deliveryOptionsQueryOptions(city: string) {
  return queryOptions({
    queryKey: deliveryKeys.options(city.trim().toLowerCase()),
    queryFn: ({ signal }) =>
      browserApiRequest(`/api/delivery/options?city=${encode(city)}`, DeliveryOptionListSchema, {
        signal,
      }),
    staleTime: 60_000,
  });
}

export function pickupPointsQueryOptions(city: string) {
  return queryOptions({
    queryKey: deliveryKeys.points(city.trim().toLowerCase()),
    queryFn: ({ signal }) =>
      browserApiRequest(`/api/delivery/pickup-points?city=${encode(city)}`, PickupPointListSchema, {
        signal,
      }),
    staleTime: 5 * 60_000,
  });
}
